import type {CallSummary} from '../../../../store/features/calls/callsService';
import {formatPhoneNumbersInText} from './formatPhoneNumbersInText';

export const legacyBullets = (summary: string | null | undefined): string[] =>
    (summary ?? '')
        .split(/(?:\r?\n)+/)
        .map((line) => formatPhoneNumbersInText(line.replace(/^\s*[-•*]\s*/, '').trim()))
        .filter(Boolean);

export interface SummaryTextLabels {
    keyPoints: string;
    nextSteps: string;
    topics: string;
    meetings: string;
}

export const summaryToText = (summary: CallSummary | undefined, labels: SummaryTextLabels): string => {
    const insights = summary?.insights;
    if (!insights) return legacyBullets(summary?.summary).map((line) => `• ${line}`).join('\n');
    const sections: string[] = [];
    if (insights.headline) sections.push(insights.headline);
    const list = (title: string, items: string[]) => {
        if (items.length) sections.push([title, ...items.map((item) => `• ${item}`)].join('\n'));
    };
    list(labels.keyPoints, (insights.keyPoints ?? []).map((point) => point.text));
    list(labels.nextSteps, (insights.nextSteps ?? []).map((step) => step.text));
    list(labels.meetings, (insights.meetings ?? []).map((meeting) => [meeting.title, meeting.date, meeting.time].filter(Boolean).join(' ')));
    if (insights.topics?.length) sections.push(`${labels.topics}: ${insights.topics.map((topic) => topic.label).join(', ')}`);
    return sections.join('\n\n');
};
